module.exports = __webpack_public_path__ + "img/exam.64f40ccb.jpg";